import { Skeleton } from '@/components/ui/skeleton'

export function InterventionDetailSkeleton() {
  return (
    <div className='p-6 space-y-2 text-sm min-h-screen flex-1 overflow-x-hidden bg-white'>
      <div className='flex flex-col justify-center gap-2 mb-3'>
        {/* External ID */}
        <Skeleton className='h-4 w-20' />

        {/* Title row with actions */}
        <div className='flex items-center justify-between'>
          <Skeleton className='h-8 w-64' />
          <Skeleton className='h-9 w-24' />
        </div>

        {/* Status badge */}
        <Skeleton className='h-6 w-32 rounded-full' />

        {/* Site & Equipment info */}
        <div className='flex items-center gap-2'>
          <Skeleton className='h-4 w-40' />
          <Skeleton className='h-4 w-4 rounded-full' />
          <Skeleton className='h-4 w-32' />
        </div>
      </div>

      {/* Info grid - matches the 6-column grid in InterventionHeader */}
      <div className='grid grid-cols-6 border rounded-md'>
        {/* Priority */}
        <div className='py-2 px-3 border-r col-span-1 place-content-center'>
          <Skeleton className='h-3 w-12 mb-1' />
          <Skeleton className='h-5 w-16 rounded-full' />
        </div>

        {/* Created date */}
        <div className='py-2 px-3 border-r col-span-1 place-content-center'>
          <Skeleton className='h-3 w-14 mb-1' />
          <Skeleton className='h-4 w-20' />
        </div>

        {/* Creator */}
        <div className='py-2 px-3 border-r col-span-2 place-content-center'>
          <Skeleton className='h-3 w-14 mb-1' />
          <div className='flex items-center gap-2'>
            <Skeleton className='size-5 rounded-full' />
            <Skeleton className='h-4 w-24' />
          </div>
        </div>

        {/* Requested date */}
        <div className='py-2 px-3 col-span-2 place-content-center'>
          <Skeleton className='h-3 w-36 mb-1' />
          <Skeleton className='h-4 w-28' />
        </div>
      </div>

      {/* Tabs skeleton */}
      <div className='flex w-full flex-col gap-6 pt-4'>
        <div className='border-b-1 border-b-border w-full'>
          <div className='flex gap-2 pb-2'>
            <Skeleton className='h-8 w-24' />
            <Skeleton className='h-8 w-20' />
            <Skeleton className='h-8 w-16' />
            <Skeleton className='h-8 w-24' />
            <Skeleton className='h-8 w-16' />
          </div>
        </div>

        {/* Tab content skeleton - simulates DetailsTab content */}
        <div className='space-y-6'>
          {/* InfoCard skeleton */}
          <div className='border rounded-lg p-4 space-y-4'>
            <Skeleton className='h-5 w-40 mb-4' />
            <div className='space-y-3'>
              <div>
                <Skeleton className='h-3 w-28 mb-1' />
                <Skeleton className='h-4 w-36' />
              </div>
              <div>
                <Skeleton className='h-3 w-16 mb-1' />
                <Skeleton className='h-4 w-48' />
              </div>
              <div>
                <Skeleton className='h-3 w-20 mb-1' />
                <Skeleton className='h-4 w-24' />
              </div>
              <div>
                <Skeleton className='h-3 w-32 mb-1' />
                <Skeleton className='h-4 w-full max-w-md' />
                <Skeleton className='h-4 w-3/4 max-w-sm mt-1' />
              </div>
            </div>
          </div>

          {/* Second InfoCard skeleton */}
          <div className='border rounded-lg p-4 space-y-4'>
            <Skeleton className='h-5 w-32 mb-4' />
            <div className='flex items-center gap-3'>
              <Skeleton className='size-10 rounded-full' />
              <div className='space-y-1'>
                <Skeleton className='h-4 w-32' />
                <Skeleton className='h-3 w-40' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
